export const environment = {
  getBaseUrl() {
    switch (window.location.host) {
      case 'coaf-lienholder-mfe.cloud.capitalone.com':
        return 'https://api.capitalone.com';
      case 'coaf-lienholder-mfe-qa.clouddqtext.capitalone.com':
        return 'https://api-it.capitalone.com';
      case 'coaf-lienholder-mfe-dev.clouddqtext.capitalone.com':
        return 'https://fs-lienholder-bff-dev.clouddqt.capitalone.com';
      case 'coaf-lienholder-mfe-perf.clouddqtext.capitalone.com':
        return 'https://api-it.capitalone.com';
      default:
        return 'https://api-it.capitalone.com';
    }
  },
  get isProdEnv() {
    return [
      'autorefi.capitalone.com',
      'coaf-refi-web-ui.capitalone.com',
      'coaf-lienholder-mfe.capitalone.com',
    ].includes(window.location.hostname);
  },
};
